import script from "./WebsiteNav.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteNav.vue?vue&type=script&setup=true&lang=js"

import "./WebsiteNav.vue?vue&type=style&index=0&id=4f9977da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f9977da"]])

export default __exports__